module.exports = __webpack_public_path__ + "img/champagne.e3a27c1e.svg";